import React from 'react';
import NotFoundImage from 'assets/images/illustrations/not-found.svg';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className='page-not-found text-center py-70'>
      <img src={NotFoundImage} className='mb-20' alt='not-found' />
      <h1 className='mb-10'>{t('title_not_found')}</h1>
      <p className='col-12 col-md-4 p-0 m-auto'>{t('text_not_found')}</p>
      <Link to='/' className='btn btn-primary mt-15'>
        {t('btn_go_home')}
      </Link>
    </div>
  );
};

export default NotFound;
